import { usePrevious } from '@btime/react-hooks'
import React, { useState, useEffect } from 'react'

const StateContext = React.createContext()
const StateProvider = StateContext.Provider

const ActionsContext = React.createContext()
const ActionsProvider = ActionsContext.Provider

export const useForceOpenState = () => React.useContext(StateContext)
export const useForceOpenActions = () => React.useContext(ActionsContext) || {}

export const useForceOpenObservable = (open, setOpen) => {
  const forceOpen = useForceOpenState()
  const previousForceOpen = usePrevious(forceOpen)
  useEffect(() => {
    if (previousForceOpen !== forceOpen && !!forceOpen && !open) {
      setOpen(true)
    }
  }, [open, forceOpen, setOpen])
}

const OpenCloseGroup = ({ children }) => {
  const [forceOpen, setForceOpen] = useState(false)

  const handleToggle = open => {
    if (!open && !!forceOpen) {
      setForceOpen(undefined)
    }
  }

  return (
    <ActionsProvider value={{ handleToggle, setForceOpen }}>
      <StateProvider value={forceOpen}>{children}</StateProvider>
    </ActionsProvider>
  )
}

export default OpenCloseGroup
